import { render, staticRenderFns } from "./_UserActivityLogs.vue?vue&type=template&id=3ed52cbc&scoped=true&"
import script from "./_UserActivityLogs.vue?vue&type=script&lang=ts&"
export * from "./_UserActivityLogs.vue?vue&type=script&lang=ts&"
import style0 from "./_UserActivityLogs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./_UserActivityLogs.vue?vue&type=style&index=1&id=3ed52cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed52cbc",
  null
  
)

export default component.exports